import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { createFrontendModule } from '@backstage/frontend-plugin-api';

// Create the entity card extension for ArgoTerminalCard
const argoTerminalEntityCard = EntityCardBlueprint.make({
  name: 'argo-terminal',
  params: {
    type: 'content',
    filter: {
      'metadata.annotations.argocd/app-name': { $exists: true },
    },
    loader: async () => {
      const { ArgoTerminalCard } = await import('./ArgoTerminalCard');
      return <ArgoTerminalCard />;
    },
  },
});

// Export as a catalog plugin extension module, not a standalone plugin
export default createFrontendModule({
  pluginId: 'catalog',
  extensions: [argoTerminalEntityCard],
});
